export const NEW_PROPOSED_COMMUNITY_MEMBERS = 'new_proposed_community_members';
export const UPDATED_COMMUNITIES = 'updated_communities';
export const NEW_ASSIGNMENTS = 'new_assignments';
export const UPDATED_ASSIGNMENTS = 'updated_assignments';
export const UPDATED_THREADS = 'updated_threads';
